import React from "react";
import { string, number, func } from "prop-types";
import DatePicker from "material-ui/DatePicker";
import TimePicker from "material-ui/TimePicker";
import TextField from "material-ui/TextField";
import FloatingActionButton from "material-ui/FloatingActionButton";
import FontIcon from "material-ui/FontIcon";
import { getDateTimeFormat } from '../utils/dateUtil'

const commonStyle = {
  margin: 10
};

const inputDureeStyle = {
  width: "auto",
  margin: 10
};

const backgroundWhite = { backgroundColor: "white" }


function TableRowTrajets({ id, dateTrajet, horaireTrajet, hours, minutes, distance, onUpdateTrajet, onDeleteTrajet }) {

  const onChange = (e) => {
    const { name, value } = e.target;
    onUpdateTrajet({ id, [name]: value })
  };

  const onChangeDate = (e, value) => onUpdateTrajet({ id, "dateTrajet": value });

  const onChangeHour = (e, value) => onUpdateTrajet({ id, "horaireTrajet": value });

  let DateTimeFormat = getDateTimeFormat();

  return (
    <tr>
      <td style={backgroundWhite} data-th="Date">
        <DatePicker
          textFieldStyle={{ width: "80%" }}
          style={commonStyle}
          mode="portrait"
          minDate={new Date()}
          hintText="12/03/2018"
          DateTimeFormat={DateTimeFormat}
          okLabel="OK"
          cancelLabel="Annuler"
          locale="fr"
          value={dateTrajet}
          onChange={onChangeDate}
        />
      </td>
      <td style={backgroundWhite} data-th="Horaire">
        <TimePicker
          textFieldStyle={{ width: "80%" }}
          style={commonStyle}
          format="24hr"
          hintText="12:00"
          value={horaireTrajet}
          onChange={onChangeHour}
        />
      </td>
      <td style={backgroundWhite} data-th="Durée estimée">
        <div
          style={{ display: "flex", alignItems: "center", paddingRight: 5 }}
        >
          <TextField
            style={inputDureeStyle}
            hintText="1"
            type="number"
            min="0"
            value={hours}
            name="hours"
            onChange={onChange}
          />
          <span>H</span>
          <TextField
            style={inputDureeStyle}
            hintText="30"
            type="number"
            min="1"
            value={minutes}
            name="minutes"
            onChange={onChange}
          />
          <span>MIN</span>
        </div>
      </td>
      <td style={backgroundWhite} data-th="Distance estimée">
        <div className="container-delete-trajet">
          <TextField
            style={inputDureeStyle}
            hintText="100"
            type="number"
            min="1"
            value={distance}
            name="distance"
            onChange={onChange}
          />
          <span>KM</span>
        </div>
      </td>
      <td style={{ border: 'none', ...backgroundWhite }} data-th="Supprimer ce trajet">
        <div className="container-delete-trajet">
          <FloatingActionButton
            onClick={() => onDeleteTrajet(id)}
            mini
            backgroundColor="rgb(255, 186, 0)"
          >
            <FontIcon className="material-icons">delete</FontIcon>
          </FloatingActionButton>
        </div>
      </td>
    </tr>
  );
}

TableRowTrajets.propTypes = {
  id: number,
  dateTrajet: string,
  horaireTrajet: string,
  hours: string,
  minutes: string,
  distance: string,
  onUpdateTrajet: func,
  onDeleteTrajet: func
}

export default TableRowTrajets;
